import { Grid } from "@material-ui/core";

/**
 * PhaseInfoBanner
 *
 * Displays the Phase ID and Phase Name at the top of lender request forms.
 * Renders nothing if neither value is available.
 *
 * Props:
 *   phaseId   {string|number} — The phase identifier
 *   phaseName {string}        — The phase name
 */
const PhaseInfoBanner = ({ phaseId, phaseName }) => {
  if (!phaseId && !phaseName) return null;

  return (
    <Grid
      item
      xs={12}
      style={{
        width: "100%",
        padding: "10px 0 14px",
        marginBottom: "16px",
        borderBottom: "1px solid #e6e8ed",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "30px",
          color: "#555",
          fontSize: "14px",
        }}
      >
        {phaseId && (
          <span>
            <strong>Phase ID:&nbsp;</strong>
            {phaseId}
          </span>
        )}
        {phaseName && (
          <span>
            <strong>Phase:&nbsp;</strong>
            {phaseName}
          </span>
        )}
      </div>
    </Grid>
  );
};

export default PhaseInfoBanner;
